import { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as AiIcon } from 'assets/icons/ai.svg';

import styles from './sass/BomUnitsAnalysisInProgress.module.scss';

function BomUnitsAnalysisInProgress() {
  const { t } = useTranslation();
  const titleId = useId();

  return (
    <div
      className={styles.root}
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-labelledby={titleId}
    >
      <div className={styles.loader} aria-hidden="true">
        <span className={styles.loaderTrack} />
        <span className={styles.loaderArc} />
        <AiIcon className={styles.loaderIcon} />
      </div>
      <p className={styles.title} id={titleId}>
        {t('valueChainMap.bomUnitsAnalysisInProgressTitle')}
      </p>
      <p className={styles.description}>
        {t('valueChainMap.bomUnitsAnalysisInProgressDescription')}
      </p>
    </div>
  );
}

export default BomUnitsAnalysisInProgress;
